import { IQService } from "angular";
import { StateService } from "angular-ui-router";
import { EventEmitter } from "../../../../common/components/event-emitter";
import { IcdCorporationDetail, IcdCorporationSelect, IcdDashboardTabSelection } from "../icd-corporation-dashboard-types";
import templateUrl from "./icd-corporation-dashboard-container.component.html";

export const IcdCorporationDashboardContainerComponent = {
    bindings: {
        icdCorporationDetails: "<",
        icdCorporations: "<",
        icdCorporationID: "<",
        permissionGrants: "<",
        tabs: "<",
        selectedTab: "<",
        changeTab: "&onChangeTab"
    },
    templateUrl,
    controller: class IcdCorporationDashboardContainer {
        icdCorporations: IcdCorporationSelect[];
        icdCorporationID: number;
        icdCorporationDetails: IcdCorporationDetail;
        tabs: IcdDashboardTabSelection[];
        selectedTab: string;
        changeTab: EventEmitter<{ tab: string }>;
        constructor(private $q: IQService, private $state: StateService, private apexApiUrl: string) {
            'ngInject';
        }

        $onChanges() {
            this.icdCorporationID = this.icdCorporationDetails ? this.icdCorporationDetails.Id : null;
        }

        onChangeIcdCorporation() {
            const icdCorporationID = this.icdCorporationID;
            this.$state.go("corporations.dashboard.icdSelected.tabSelected", { icdCorporationID },
                { location: "replace", reload: "corporations.dashboard" });
        }


        onChangeTab(tab: string) {
            this.selectedTab = tab;
            this.changeTab({
                $event: {
                    tab
                }
            });
        }
    }
};
